// extracted by mini-css-extract-plugin
export var promotionLink = "_vi-0";